(function () {
  var MOBILE_MQ = window.matchMedia('(max-width: 767px)');

  function initSlider(root) {
    if (root.dataset.ufcSliderMode === 'static-strip') return;
    if (root.getAttribute('data-ufc-slider-ready') === 'true') return;
    root.setAttribute('data-ufc-slider-ready', 'true');

    var viewport = root.querySelector('.ufc-mobile-slider__viewport');
    var track = root.querySelector('.ufc-mobile-slider__track');
    var slides = root.querySelectorAll('.ufc-mobile-slider__slide');
    var dotsContainer = root.querySelector('.ufc-mobile-slider__dots');
    if (!viewport || !track || !slides.length || !dotsContainer) return;

    var current = 0;
    var dots = [];
    var scrollRaf = 0;

    slides.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'ufc-mobile-slider__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.dataset.index = String(i);
      dotsContainer.appendChild(dot);
      dots.push(dot);
    });

    function setSlideWidths() {
      if (!isMobile()) {
        slides.forEach(function (slide) {
          slide.style.flexBasis = '';
          slide.style.width = '';
          slide.style.minWidth = '';
        });
        return;
      }
      var w = viewport.clientWidth;
      slides.forEach(function (slide) {
        slide.style.flexBasis = w + 'px';
        slide.style.width = w + 'px';
        slide.style.minWidth = w + 'px';
      });
    }

    function isMobile() {
      return MOBILE_MQ.matches;
    }

    function slideOffset(idx) {
      var slide = slides[idx];
      if (!slide) return 0;
      var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
      return Math.max(0, slideCenter - viewport.clientWidth / 2);
    }

    function syncDots(idx) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === idx);
      });
    }

    function nearestIndex() {
      var center = viewport.scrollLeft + viewport.clientWidth / 2;
      var closest = 0;
      var minDiff = Infinity;
      slides.forEach(function (slide, i) {
        var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        var diff = Math.abs(slideCenter - center);
        if (diff < minDiff) {
          minDiff = diff;
          closest = i;
        }
      });
      return closest;
    }

    function goTo(idx, smooth) {
      if (!isMobile()) {
        viewport.scrollLeft = 0;
        track.style.transform = '';
        return;
      }

      setSlideWidths();
      current = ((idx % slides.length) + slides.length) % slides.length;
      viewport.scrollTo({
        left: slideOffset(current),
        behavior: smooth === false ? 'auto' : 'smooth',
      });
      syncDots(current);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(Number(dot.dataset.index), true);
      });
    });

    var prevArrow = root.querySelector('.ufc-mobile-slider__arrow--prev');
    var nextArrow = root.querySelector('.ufc-mobile-slider__arrow--next');
    if (prevArrow) {
      prevArrow.addEventListener('click', function () { goTo(current - 1, true); });
    }
    if (nextArrow) {
      nextArrow.addEventListener('click', function () { goTo(current + 1, true); });
    }

    viewport.addEventListener(
      'scroll',
      function () {
        if (!isMobile()) return;
        if (scrollRaf) return;
        scrollRaf = window.requestAnimationFrame(function () {
          scrollRaf = 0;
          current = nearestIndex();
          syncDots(current);
        });
      },
      { passive: true }
    );

    MOBILE_MQ.addEventListener('change', function () {
      setSlideWidths();
      goTo(current, false);
    });
    window.addEventListener('resize', function () {
      setSlideWidths();
      goTo(current, false);
    });

    setSlideWidths();
    goTo(0, false);
  }

  function boot() {
    document.querySelectorAll('[data-ufc-mobile-slider]').forEach(initSlider);
  }

  if (window.__ufcMobileSliderBooted) {
    boot();
  } else {
    window.__ufcMobileSliderBooted = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  }
})();
